/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnsignupMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type UnsignupMutation = { readonly __typename?: 'Mutation', readonly Unsignup: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly allowedBillingCycles: ReadonlyArray<GraphQL.Term>, readonly allowedCurrencies: ReadonlyArray<GraphQL.Currency>, readonly allowedPaymentMethods: ReadonlyArray<string>, readonly allowedPlans: ReadonlyArray<GraphQL.AccountPlan>, readonly billingCycle: GraphQL.Term, readonly billingEntity: GraphQL.SubscriptionsSellerCode, readonly canHaveMoreConnectedTrialAccounts: boolean, readonly canManagersAffectSubscription: boolean, readonly canManagersControlAgencyAccess: boolean, readonly canManagersSeeApiTokens: boolean, readonly canSelfServiceSignupRemoveWebsiteLimit: boolean, readonly canSignup: boolean, readonly currency: GraphQL.Currency | null, readonly customElementsLimit: number, readonly endUserPlan: GraphQL.EndUserPlan | null, readonly enrichmentFieldsLimit: number, readonly fixedBillingEntity: GraphQL.SubscriptionsSellerCode | null, readonly id: CK.AccountId, readonly isCleanedUp: boolean, readonly isDeliveryAddressEnabled: boolean, readonly isExtraInvoiceDetailsEnabled: boolean, readonly isOutOfBand: boolean, readonly isTrialBarDisplayed: boolean, readonly isTrialExtensionAllowed: boolean, readonly maximumRegularSignupPageBundle: number | null, readonly maximumSignupPageBundle: number | null, readonly pageBundle: number | null, readonly paidUntil: CK.Timestamp | null, readonly phase: GraphQL.AccountPhase, readonly plan: GraphQL.AccountPlan | null, readonly state: GraphQL.AccountState, readonly tariff: string, readonly trialExpirationDate: CK.Timestamp | null, readonly trialRevivalDate: CK.Timestamp | null, readonly type: GraphQL.AccountType, readonly unpaidPhase: GraphQL.AccountUnpaidPhase | null, readonly unpaidSince: CK.Timestamp | null, readonly unpaidSituation: GraphQL.AccountUnpaidSituation | null, readonly availableAddons: ReadonlyArray<{ readonly __typename?: 'AccountAvailableAddon', readonly addonType: GraphQL.AddonType, readonly maximumAmount: number }>, readonly billingDetails: { readonly __typename?: 'AccountBillingDetails', readonly email: string } | null, readonly connectedAdobeAnalyticsAccounts: ReadonlyArray<{ readonly __typename?: 'AdobeAnalyticsAccount', readonly id: number }> | null, readonly connectedGoogleAnalyticsAccounts: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsAccount', readonly id: CK.ID }> | null, readonly discounts: ReadonlyArray<{ readonly __typename?: 'Discount', readonly coupon: string, readonly percentage: CK.Percentage | null, readonly type: GraphQL.DiscountType, readonly amount: ReadonlyArray<{ readonly __typename?: 'DiscountExactAmount', readonly currency: GraphQL.Currency, readonly value: number }> | null }>, readonly features: ReadonlyArray<{ readonly __typename?: 'AccountFeatureState', readonly feature: GraphQL.AccountFeature, readonly id: CK.ID, readonly inUse: boolean }>, readonly paymentMethod: { readonly __typename?: 'AccountPaymentMethod', readonly type: string } | null, readonly paymentStatus: { readonly __typename?: 'AccountPaymentStatus', readonly isOkay: boolean } | null, readonly premiumTrial: { readonly __typename?: 'AccountPremiumTrial', readonly expirationDate: CK.Timestamp, readonly plan: GraphQL.AccountPlan } | null, readonly premiumTrialOffer: { readonly __typename?: 'AccountPremiumTrialOffer', readonly durationInDays: number, readonly plan: GraphQL.AccountPlan } | null, readonly userRestrictions: { readonly __typename?: 'AccountUserRestrictions', readonly emailDomainsWhitelist: ReadonlyArray<string> | null, readonly maximumInvitations: number }, readonly websiteRestrictions: { readonly __typename?: 'AccountWebsiteRestrictions', readonly domainsWhitelist: ReadonlyArray<string> | null, readonly maximumPageBundle: number | null, readonly maximumPageCapacity: number, readonly maximumUnverifiedWebsites: number | null, readonly maximumWebsites: number | null }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> } | null } } };


export const UnsignupDocument = gql`
    mutation Unsignup($accountId: AccountId!) {
  Unsignup(accountId: $accountId) {
    query {
      account(id: $accountId) {
        allowedBillingCycles
        allowedCurrencies
        allowedPaymentMethods
        allowedPlans
        availableAddons {
          addonType
          maximumAmount
        }
        billingCycle
        billingDetails {
          email
        }
        billingEntity
        canHaveMoreConnectedTrialAccounts
        canManagersAffectSubscription
        canManagersControlAgencyAccess
        canManagersSeeApiTokens
        canSelfServiceSignupRemoveWebsiteLimit
        canSignup
        connectedAdobeAnalyticsAccounts {
          id
        }
        connectedGoogleAnalyticsAccounts {
          id
        }
        currency
        customElementsLimit
        discounts {
          amount {
            currency
            value
          }
          coupon
          percentage
          type
        }
        endUserPlan
        enrichmentFieldsLimit
        features {
          feature
          id
          inUse
        }
        fixedBillingEntity
        id
        isCleanedUp
        isDeliveryAddressEnabled
        isExtraInvoiceDetailsEnabled
        isOutOfBand
        isTrialBarDisplayed
        isTrialExtensionAllowed
        maximumRegularSignupPageBundle
        maximumSignupPageBundle
        pageBundle
        paidUntil
        paymentMethod {
          type
        }
        paymentStatus {
          isOkay
        }
        phase
        plan
        premiumTrial {
          expirationDate
          plan
        }
        premiumTrialOffer {
          durationInDays
          plan
        }
        state
        tariff
        trialExpirationDate
        trialRevivalDate
        type
        unpaidPhase
        unpaidSince
        unpaidSituation
        userRestrictions {
          emailDomainsWhitelist
          maximumInvitations
        }
        websiteRestrictions {
          domainsWhitelist
          maximumPageBundle
          maximumPageCapacity
          maximumUnverifiedWebsites
          maximumWebsites
        }
        websites {
          id
        }
      }
    }
  }
}
    `;
export type UnsignupMutationFn = Apollo.MutationFunction<UnsignupMutation, UnsignupMutationVariables>;

/**
 * __useUnsignupMutation__
 *
 * To run a mutation, you first call `useUnsignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsignupMutation, { data, loading, error }] = useUnsignupMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useUnsignupMutation(baseOptions?: Apollo.MutationHookOptions<UnsignupMutation, UnsignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsignupMutation, UnsignupMutationVariables>(UnsignupDocument, options);
      }
export type UnsignupMutationHookResult = ReturnType<typeof useUnsignupMutation>;
export type UnsignupMutationResult = Apollo.MutationResult<UnsignupMutation>;
export type UnsignupMutationOptions = Apollo.BaseMutationOptions<UnsignupMutation, UnsignupMutationVariables>;